/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
/**
* CSS Custom Properties
*
* These properties can be overridden using the component's tag as selector.
*
* @prop --calcite-tab-content-block-padding: Specifies the block padding of the component's content in the `default` slot.
*/
:host([selected]) section,
:host([selected]) .container {
  display: block;
}

:host {
  display: none;
  block-size: 100%;
  inline-size: 100%;
}

:host([selected]) {
  display: block;
  block-size: 100%;
  inline-size: 100%;
  overflow: auto;
}

.content {
  box-sizing: border-box;
  padding-block: var(--calcite-internal-tab-content-block-padding);
}

.scale-s {
  --calcite-internal-tab-content-block-padding: var(--calcite-tab-content-block-padding, 0.25rem);
  font-size: var(--calcite-font-size--2);
  line-height: 1rem;
}

.scale-m {
  --calcite-internal-tab-content-block-padding: var(--calcite-tab-content-block-padding, 0.5rem);
  font-size: var(--calcite-font-size--1);
  line-height: 1rem;
}

.scale-l {
  --calcite-internal-tab-content-block-padding: var(--calcite-tab-content-block-padding, 0.625rem);
  font-size: var(--calcite-font-size-0);
  line-height: 1.25rem;
}

section,
.container {
  display: none;
  block-size: 100%;
  inline-size: 100%;
}

.container {
  outline-color: transparent;
}
.container:focus {
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
  outline-offset: calc(
            -2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          );
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}